module.exports = __webpack_public_path__ + "static/media/create-project.1edd231e.png";